/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Picks_Done_DescriptionInputs */

const en_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’ve unlocked every item here. Amazing!`)
};

const ar_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد فتحت جميع العناصر هنا. رائع!`)
};

const de_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast hier alle Artikel freigeschaltet. Großartig!`)
};

const es_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has desbloqueado todos los artículos de aquí. ¡Genial!`)
};

const fr_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as débloqué tous les articles ici. Bravo !`)
};

const it_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai sbloccato tutti gli articoli qui. Fantastico!`)
};

const ja_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにあるアイテムをすべてアンロックしました。すごい！`)
};

const ko_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기 있는 모든 아이템을 잠금 해제했어요. 대단해요!`)
};

const pt_br_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você desbloqueou todos os itens daqui. Incrível!`)
};

const ru_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы разблокировали здесь все предметы. Потрясающе!`)
};

const th_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณปลดล็อกไอเท็มทั้งหมดที่นี่แล้ว สุดยอด!`)
};

const tr_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buradaki tüm öğelerin kilidini açtın. Harika!`)
};

const zh_cn_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已解锁这里所有商品，太厉害了！`)
};

const zh_tw_daily_picks_done_description = /** @type {(inputs: Daily_Picks_Done_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已解鎖這裡所有商品，太厲害了！`)
};

/**
* | output |
* | --- |
* | "You’ve unlocked every item here. Amazing!" |
*
* @param {Daily_Picks_Done_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_picks_done_description = /** @type {((inputs?: Daily_Picks_Done_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Picks_Done_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_picks_done_description(inputs)
	if (locale === "ar") return ar_daily_picks_done_description(inputs)
	if (locale === "de") return de_daily_picks_done_description(inputs)
	if (locale === "es") return es_daily_picks_done_description(inputs)
	if (locale === "fr") return fr_daily_picks_done_description(inputs)
	if (locale === "it") return it_daily_picks_done_description(inputs)
	if (locale === "ja") return ja_daily_picks_done_description(inputs)
	if (locale === "ko") return ko_daily_picks_done_description(inputs)
	if (locale === "pt_br") return pt_br_daily_picks_done_description(inputs)
	if (locale === "ru") return ru_daily_picks_done_description(inputs)
	if (locale === "th") return th_daily_picks_done_description(inputs)
	if (locale === "tr") return tr_daily_picks_done_description(inputs)
	if (locale === "zh_cn") return zh_cn_daily_picks_done_description(inputs)
	return zh_tw_daily_picks_done_description(inputs)
});